import React, { useEffect, useState } from "react";
import { Button, CloseButton, Offcanvas } from "react-bootstrap";
import CallResponse from "./CallResponse";
import SaveFeedback from "./SaveFeedBack";
import Comments from "./Comments";
import Tick from "assets/svgs/tick";
import BlueTick from "assets/svgs/blue_tick";
import { DispositionComponent } from "../../lead_Detail_pop_up/DispositionComponent";
import { DISP_FLAG } from "../../utilities/utility";

function PrescriptionFeedbackForm({ week, id, bookingId, list, customer }) {
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    callResponse: null,
    comments: null,
  });
  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
  ];
  const formRow = "d-flex gap-3";
  const buttonStyle =
    "border rounded-2 mb-0 p-2 cursor-pointer option-hover flex-1 text-center";
  const selected =
    "border rounded-2 mb-0 p-2 cursor-pointer bg-primary text-white flex-1 text-center";

  const handleShow = (breakpoint) => {
    setFullscreen(breakpoint);
    setShow(true);
  };
  const pushComponent = (name, value) => {
    renderedComponents.push({ name, value });
  };
  useEffect(() => {}, [week]);
  return (
    <>
      {list ? (
        <div className="cursor-pointer" onClick={() => handleShow("lg-down")}>
          <BlueTick />
        </div>
      ) : (
        <Button className="flex-1" onClick={() => handleShow("lg-down")}>
          <Tick />
        </Button>
      )}
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: DISP_FLAG ?"77%":"40%" }}
        onHide={() => setShow(false)}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setShow(false)}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "85vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
          <div className="d-flex gap-3 flex-row">
            <div>
            {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
          <div>
            <CallResponse
              formData={formData}
              buttonStyle={buttonStyle}
              selected={selected}
              setFormData={setFormData}
              formRow={formRow}
            />
            {formData.callResponse === "answered" && (
              <div className="mt-3">
                <Comments setFormData={setFormData} />
                {pushComponent("comments", formData.comments)}
              </div>
            )}
            {["unanswered", "languageIssue"].includes(formData?.callResponse) && (
              <SaveFeedback
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
              />
            )}
            {formData.callResponse === "answered" &&
              formData.comments &&
              formData.comments.length > 5 && (
                <SaveFeedback
                  setShow={setShow}
                  bookingId={bookingId}
                  week={week}
                  formData={formData}
                  selected={selected}
                  buttonStyle={buttonStyle}
                  formRow={formRow}
                  renderedComponents={renderedComponents}
                  id={id}
                />
              )}
          </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default PrescriptionFeedbackForm;
